import { invokeApi } from "src/bl_libs/invokeApi";

export const getProgressReportWeeksApi = async (trackerId) => {
  const requestObj = {
    path: `api/tracker_progress_report/weeks/${trackerId}`,
    method: "GET",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
  };
  return invokeApi(requestObj);
};

export const previewProgressReportApi = async (data = {}) => {
  const requestObj = {
    path: `api/tracker_progress_report/preview`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};

export const sendProgressReportApi = async (data = {}) => {
  const requestObj = {
    path: `api/tracker_progress_report/send`,
    method: "POST",
    headers: {
      "x-sh-auth": localStorage.getItem("token"),
    },
    postData: data,
  };
  return invokeApi(requestObj);
};
